import { useLang } from "@/i18n";
import { PageHero } from "@/components/common";
import { RoadmapTimeline } from "@/components/home/RoadmapTimeline";

export default function Roadmap() {
  const { t } = useLang();
  return (
    <>
      <PageHero eyebrow={t("road.eyebrow")} title={t("road.title")} />
      <RoadmapTimeline withHead={false} />
    </>
  );
}
